import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    marginTop: '95px',
    flexDirection: 'column',
  },
  gridContainer: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  profilePaper: {
    paddingTop: '30px',
    height: '100%',
    borderRadius: '16px',
    boxShadow: `0 0 2px 2px rgb(0 0 0 / 0.2)`,
    [theme.breakpoints.down('xs')]: {
      paddingTop: '10px',
    },
  },
  profileContainer: {
    margin: '30px auto 0 auto',
    width: '100px',
  },
  paperTab: {
    marginBottom: '25px',
    textAlign: 'center',
    borderRadius: '14px',
    boxShadow: `0 0 2px 2px rgb(0 0 0 / 0.2)`,
    [theme.breakpoints.down('sm')]: {
      marginTop: '25px',
      marginBottom: '20px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  tabTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    padding: 9,
  },

  profilePic: {
    width: '100px',
    height: '100px',
  },
  profileDetails: {
    textAlign: 'center',
    padding: 24,
  },
  profileName: {
    textAlign: 'center',
  },
  userName: {
    marginBottom: '10px',
  },
  followeditButton: {
    backgroundColor: '#000',
    color: '#fff',
    margin: '10px auto',
    height: '30px',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.6rem',
    },
  },
  bio: {
    marginTop: '10px',
  },
}))
